import * as types from "../../_constants/types";

export default (state = null, action) => {
    switch (action.type) {
        case types.TICKET_LOAD:
            return Object.assign({}, action.data);

        case types.RESET:
        case types.TICKET_RESET:
            return null;

        default:
            return state;
    }
};
